export const ApiErrorKeys = {
    USER_INVITE_LIMIT: 'USER_INVITE_LIMIT',
    ADMIN_INVITE_LIMIT: 'ADMIN_INVITE_LIMIT',
    USER_SEND_PASSWORD_FAILED: 'USER_SEND_PASSWORD_FAILED',
    ADMIN_SEND_PASSWORD_FAILED: 'ADMIN_SEND_PASSWORD_FAILED',
    /** Async CSV preview: per-row messages live in status poll `summary.validation_errors`. */
    USER_CSV_PREVIEW_VALIDATION: 'USER_CSV_PREVIEW_VALIDATION',
    REPORT_CATEGORY_SUSPENDED: 'REPORT_CATEGORY_SUSPENDED',
    REPORT_CATEGORY_NOT_FOUND: 'REPORT_CATEGORY_NOT_FOUND',
};
